export { default as AlertCircle } from './alert-circle.svg?react';
export { default as Bell } from './bell.svg?react';
export { default as CarManagement } from './car-management.svg?react';
export { default as Car } from './car.svg?react';
export { default as CheckCircle } from './check-circle.svg?react';
export { default as ChevronDown } from './chevron-down.svg?react';
export { default as EyeOff } from './eye-off.svg?react';
export { default as Eye } from './eye.svg?react';
export { default as Grid } from './grid.svg?react';
export { default as Home } from './home.svg?react';
export { default as Key } from './key.svg?react';
export { default as Paperclip } from './paperclip.svg?react';
export { default as Percent } from './percent.svg?react';
export { default as Phone } from './phone.svg?react';
export { default as Send } from './send.svg?react';
export { default as User } from './user.svg?react';
export { default as X } from './x.svg?react';
